import script from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailRightSide.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=d12b7d50&scoped=true&lang=css&external"
import "./TaskDetailRightSide.vue?vue&type=style&index=1&id=d12b7d50&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d12b7d50"]])

export default __exports__